/**
 * @file 创意机会迁移至 Creative+ 提示卡片
 * @description is_creative_assets_enable 已全量上线，挂在「机会」侧边栏底部，
 *              引导用户跳转至 Creative+。
 *              展示由 FF `is_show_creative_migration_tip` 控制。
 */

import React, { useCallback } from 'react';
// import { hasFeatureFlagSuper } from '@/services';
import globalStore from '@/stores/index';

import titleCreative from './assets/title-creative.svg';
import titlePlus from './assets/title-plus.svg';
import arrowRight from './assets/arrow-right.svg';
import decoration from './assets/decoration.svg';

import './index.less';

const CREATIVE_PLUS_INSIGHT_URL = '/creative-assets';

const CreativeMigrationTip: React.FC = () => {
  const handleClick = useCallback(() => {
    const history: any = globalStore.history;
    if (history?.push) {
      history.push(CREATIVE_PLUS_INSIGHT_URL);
    } else {
      window.location.href = CREATIVE_PLUS_INSIGHT_URL;
    }
  }, []);

  const handleViewClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      handleClick();
    },
    [handleClick],
  );

  // if (!hasFeatureFlagSuper('is_show_creative_migration_tip')) {
  //   return null;
  // }

  return (
    <div
      className="creative-migration-card"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      data-report-global="click_sidebar_creative_migration_tip"
    >
      <span className="creative-migration-card__glow" aria-hidden />

      <img
        className="creative-migration-card__decoration"
        src={decoration}
        alt=""
        aria-hidden
      />

      <div className="creative-migration-card__header">
        <p className="creative-migration-card__lead">创意机会已迁移至</p>
        <div className="creative-migration-card__brand" aria-label="Creative+">
          <img
            className="creative-migration-card__brand-text"
            src={titleCreative}
            alt="Creative"
          />
          <img
            className="creative-migration-card__brand-plus"
            src={titlePlus}
            alt="+"
          />
        </div>
      </div>

      <button
        type="button"
        className="creative-migration-card__cta"
        onClick={handleViewClick}
      >
        <span className="creative-migration-card__cta-text">立即查看</span>
        <img
          className="creative-migration-card__cta-arrow"
          src={arrowRight}
          alt=""
          aria-hidden
        />
      </button>
    </div>
  );
};

export default CreativeMigrationTip;
